import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class TenantOpportunitySettingsService {
  getSettings() {
    return ApiService.get(`${Config.api.document.url}api/v1/tenant-opportunity-settings`)
      .then((response) => response.data)
      .catch((error) => {
        throw this.mapError(error);
      });
  }

  updateSettings(settings) {
    return ApiService.put(`${Config.api.document.url}api/v1/tenant-opportunity-settings`, settings)
      .then((response) => response.data)
      .catch((error) => {
        throw this.mapError(error);
      });
  }

  mapError(error) {
    if (error.response && error.response.data) return error.response.data;
    else if (error.response) return error.response;
    else if (error.request) return error.request;
    else return error.message;
  }
}

export const tenantOpportunitySettingsService = new TenantOpportunitySettingsService();
